/* eslint-disable */

!(function (D, u) {
  'object' == typeof exports && 'undefined' != typeof module
    ? u(exports)
    : 'function' == typeof define && define.amd
    ? define(['exports'], u)
    : u(((D = D || self).window = D.window || {}));
})(this, function (e) {
  var v =
    /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
  function m() {
    return String.fromCharCode.apply(null, arguments);
  }
  function p(D) {
    return F.getComputedStyle(D);
  }
  function s(D, u) {
    var e;
    return d(D)
      ? D
      : 'string' == (e = typeof D) && !u && D
      ? a.call(Q.querySelectorAll(D), 0)
      : D && 'object' == e && 'length' in D
      ? a.call(D, 0)
      : D
      ? [D]
      : [];
  }
  function t(D) {
    return 'absolute' === D.position || !0 === D.absolute;
  }
  function u(D, u) {
    for (var e, t = u.length; -1 < --t; )
      if (((e = u[t]), D.substr(0, e.length) === e)) return e.length;
  }
  function w(D, u) {
    void 0 === D && (D = '');
    var e = ~D.indexOf('++'),
      t = 1;
    return (
      e && (D = D.split('++').join('')),
      function () {
        return (
          '<' +
          u +
          " style='position:relative;display:inline-block;'" +
          (D ? " class='" + D + (e ? t++ : '') + "'>" : '>')
        );
      }
    );
  }
  function x(D, u, e) {
    var t = D.nodeType;
    if (1 === t || 9 === t || 11 === t)
      for (D = D.firstChild; D; D = D.nextSibling) x(D, u, e);
    else (3 !== t && 4 !== t) || (D.nodeValue = D.nodeValue.split(u).join(e));
  }
  function y(D, u) {
    for (var e = u.length; -1 < --e; ) D.push(u[e]);
  }
  function z(D, u, e) {
    for (var t; D && D !== u; ) {
      if ((t = D._next || D.nextSibling)) return t.textContent.charAt(0) === e;
      D = D.parentNode || D._parent;
    }
  }
  function A(D) {
    var u,
      e,
      t = s(D.childNodes),
      F = t.length;
    for (u = 0; u < F; u++)
      (e = t[u])._isSplit
        ? A(e)
        : (u && 3 === e.previousSibling.nodeType
            ? (e.previousSibling.nodeValue +=
                3 === e.nodeType ? e.nodeValue : e.firstChild.nodeValue)
            : 3 !== e.nodeType && D.insertBefore(e.firstChild, e),
          D.removeChild(e));
  }
  function B(D, u) {
    return parseFloat(u[D]) || 0;
  }
  function C(D, u, e, F, C, i, n) {
    var E,
      s,
      r,
      o,
      l,
      d,
      a,
      h,
      f,
      c,
      g,
      m,
      v = p(D),
      w = B('paddingLeft', v),
      S = -999,
      b = B('borderBottomWidth', v) + B('borderTopWidth', v),
      _ = B('borderLeftWidth', v) + B('borderRightWidth', v),
      T = B('paddingTop', v) + B('paddingBottom', v),
      N = B('paddingLeft', v) + B('paddingRight', v),
      L = B('fontSize', v) * (u.lineThreshold || 0.2),
      O = v.textAlign,
      W = [],
      H = [],
      V = [],
      j = u.wordDelimiter || ' ',
      M = u.tag ? u.tag : u.span ? 'span' : 'div',
      R = u.type || u.split || 'chars,words,lines',
      k = C && ~R.indexOf('lines') ? [] : null,
      P = ~R.indexOf('words'),
      q = ~R.indexOf('chars'),
      G = t(u),
      I = u.linesClass,
      J = ~(I || '').indexOf('++'),
      K = [];
    for (
      J && (I = I.split('++').join('')),
        r = (s = D.getElementsByTagName('*')).length,
        l = [],
        E = 0;
      E < r;
      E++
    )
      l[E] = s[E];
    if (k || G)
      for (E = 0; E < r; E++)
        ((d = (o = l[E]).parentNode === D) || G || (q && !P)) &&
          ((m = o.offsetTop),
          k &&
            d &&
            Math.abs(m - S) > L &&
            ('BR' !== o.nodeName || 0 === E) &&
            ((a = []), k.push(a), (S = m)),
          G &&
            ((o._x = o.offsetLeft),
            (o._y = m),
            (o._w = o.offsetWidth),
            (o._h = o.offsetHeight)),
          k &&
            (((o._isSplit && d) ||
              (!q && d) ||
              (P && d) ||
              (!P &&
                o.parentNode.parentNode === D &&
                !o.parentNode._isSplit)) &&
              (a.push(o), (o._x -= w), z(o, D, j) && (o._wordEnd = !0)),
            'BR' === o.nodeName &&
              ((o.nextSibling && 'BR' === o.nextSibling.nodeName) || 0 === E) &&
              k.push([])));
    for (E = 0; E < r; E++)
      (d = (o = l[E]).parentNode === D),
        'BR' !== o.nodeName
          ? (G &&
              ((f = o.style),
              P || d || ((o._x += o.parentNode._x), (o._y += o.parentNode._y)),
              (f.left = o._x + 'px'),
              (f.top = o._y + 'px'),
              (f.position = 'absolute'),
              (f.display = 'block'),
              (f.width = o._w + 1 + 'px'),
              (f.height = o._h + 'px')),
            !P && q
              ? o._isSplit
                ? ((o._next = o.nextSibling), o.parentNode.appendChild(o))
                : o.parentNode._isSplit
                ? ((o._parent = o.parentNode),
                  !o.previousSibling &&
                    o.firstChild &&
                    (o.firstChild._isFirst = !0),
                  o.nextSibling &&
                    ' ' === o.nextSibling.textContent &&
                    !o.nextSibling.nextSibling &&
                    K.push(o.nextSibling),
                  (o._next =
                    o.nextSibling && o.nextSibling._isFirst
                      ? null
                      : o.nextSibling),
                  o.parentNode.removeChild(o),
                  l.splice(E--, 1),
                  r--)
                : d ||
                  ((m = !o.nextSibling && z(o.parentNode, D, j)),
                  o.parentNode._parent && o.parentNode._parent.appendChild(o),
                  m && o.parentNode.appendChild(Q.createTextNode(' ')),
                  'span' === M && (o.style.display = 'inline'),
                  W.push(o))
              : o.parentNode._isSplit && !o._isSplit && '' !== o.innerHTML
              ? H.push(o)
              : q &&
                !o._isSplit &&
                ('span' === M && (o.style.display = 'inline'), W.push(o)))
          : k || G
          ? (o.parentNode && o.parentNode.removeChild(o), l.splice(E--, 1), r--)
          : P || D.appendChild(o);
    for (E = K.length; -1 < --E; ) K[E].parentNode.removeChild(K[E]);
    if (k) {
      for (
        G &&
          ((c = Q.createElement(M)),
          D.appendChild(c),
          (g = c.offsetWidth + 'px'),
          (m = c.offsetParent === D ? 0 : D.offsetLeft),
          D.removeChild(c)),
          f = D.style.cssText,
          D.style.cssText = 'display:none;';
        D.firstChild;

      )
        D.removeChild(D.firstChild);
      for (h = ' ' === j && (!G || (!P && !q)), E = 0; E < k.length; E++) {
        for (
          a = k[E],
            (c = Q.createElement(M)).style.cssText =
              'display:block;text-align:' +
              O +
              ';position:' +
              (G ? 'absolute;' : 'relative;'),
            I && (c.className = I + (J ? E + 1 : '')),
            V.push(c),
            r = a.length,
            s = 0;
          s < r;
          s++
        )
          'BR' !== a[s].nodeName &&
            ((o = a[s]),
            c.appendChild(o),
            h && o._wordEnd && c.appendChild(Q.createTextNode(' ')),
            G &&
              (0 === s &&
                ((c.style.top = o._y + 'px'), (c.style.left = w + m + 'px')),
              (o.style.top = '0px'),
              m && (o.style.left = o._x - m + 'px')));
        0 === r
          ? (c.innerHTML = '&nbsp;')
          : P || q || (A(c), x(c, String.fromCharCode(160), ' ')),
          G && ((c.style.width = g), (c.style.height = o._h + 'px')),
          D.appendChild(c);
      }
      D.style.cssText = f;
    }
    G &&
      (n > D.clientHeight &&
        ((D.style.height = n - T + 'px'),
        D.clientHeight < n && (D.style.height = n + b + 'px')),
      i > D.clientWidth &&
        ((D.style.width = i - N + 'px'),
        D.clientWidth < i && (D.style.width = i + _ + 'px'))),
      y(e, W),
      P && y(F, H),
      y(C, V);
  }
  function D(D, e, F, C) {
    var i,
      n,
      E,
      s,
      r,
      o,
      l,
      d,
      p = e.tag ? e.tag : e.span ? 'span' : 'div',
      a = ~(e.type || e.split || 'chars,words,lines').indexOf('chars'),
      h = t(e),
      B = e.wordDelimiter || ' ',
      f = ' ' !== B ? '' : h ? '&#173; ' : ' ',
      A = '</' + p + '>',
      c = 1,
      g = e.specialChars
        ? 'function' == typeof e.specialChars
          ? e.specialChars
          : u
        : null,
      m = Q.createElement('div'),
      y = D.parentNode;
    for (
      y.insertBefore(m, D),
        m.textContent = D.nodeValue,
        y.removeChild(D),
        l =
          -1 !==
          (i = (function getText(D) {
            var u = D.nodeType,
              e = '';
            if (1 === u || 9 === u || 11 === u) {
              if ('string' == typeof D.textContent) return D.textContent;
              for (D = D.firstChild; D; D = D.nextSibling) e += getText(D);
            } else if (3 === u || 4 === u) return D.nodeValue;
            return e;
          })((D = m))).indexOf('<'),
        !1 !== e.reduceWhiteSpace && (i = i.replace(b, ' ').replace(S, '')),
        l && (i = i.split('<').join('{{LT}}')),
        r = i.length,
        n = (' ' === i.charAt(0) ? f : '') + F(),
        E = 0;
      E < r;
      E++
    )
      if (((o = i.charAt(E)), g && (d = g(i.substr(E), e.specialChars))))
        (o = i.substr(E, d || 1)),
          (n += a && ' ' !== o ? C() + o + '</' + p + '>' : o),
          (E += d - 1);
      else if (o === B && i.charAt(E - 1) !== B && E) {
        for (n += c ? A : '', c = 0; i.charAt(E + 1) === B; ) (n += f), E++;
        E === r - 1
          ? (n += f)
          : ')' !== i.charAt(E + 1) && ((n += f + F()), (c = 1));
      } else
        '{' === o && '{{LT}}' === i.substr(E, 6)
          ? ((n += a ? C() + '{{LT}}</' + p + '>' : '{{LT}}'), (E += 5))
          : (55296 <= o.charCodeAt(0) && o.charCodeAt(0) <= 56319) ||
            (65024 <= i.charCodeAt(E + 1) && i.charCodeAt(E + 1) <= 65039)
          ? ((s = ((i.substr(E, 12).split(v) || [])[1] || '').length || 2),
            (n +=
              a && ' ' !== o
                ? C() + i.substr(E, s) + '</' + p + '>'
                : i.substr(E, s)),
            (E += s - 1))
          : (n += a && ' ' !== o ? C() + o + '</' + p + '>' : o);
    (D.outerHTML = n + (c ? A : '')), l && x(y, '{{LT}}', '<');
  }
  function E(u, e, F, C) {
    var i,
      n,
      r = s(u.childNodes),
      o = r.length,
      l = t(e);
    if (3 !== u.nodeType || 1 < o) {
      for (e.absolute = !1, i = 0; i < o; i++)
        (3 === (n = r[i]).nodeType && !/\S+/.test(n.nodeValue)) ||
          (l &&
            3 !== n.nodeType &&
            'inline' === p(n).display &&
            ((n.style.display = 'inline-block'),
            (n.style.position = 'relative')),
          (n._isSplit = !0),
          E(n, e, F, C));
      return (e.absolute = l), void (u._isSplit = !0);
    }
    D(u, e, F, C);
  }
  var Q,
    F,
    i,
    n,
    S = /(?:\r|\n|\t\t)/g,
    b = /(?:\s\s+)/g,
    r = 'SplitText',
    o = m(103, 114, 101, 101, 110, 115, 111, 99, 107, 46, 99, 111, 109),
    l = (function (D) {
      for (
        var u =
            0 ===
              (window ? window.location.href : '').indexOf(
                m(102, 105, 108, 101, 58, 47, 47),
              ) ||
            -1 !== D.indexOf(m(108, 111, 99, 97, 108, 104, 111, 115, 116)) ||
            -1 !== D.indexOf(m(49, 50, 55, 46, 48, 32, 48, 46, 49)),
          e = [
            o,
            m(99, 111, 100, 101, 112, 101, 110, 46, 105, 111),
            m(
              99,
              111,
              100,
              101,
              112,
              101,
              110,
              46,
              112,
              108,
              117,
              109,
              98,
              105,
              110,
              103,
            ),
            m(99, 111, 100, 101, 112, 101, 110, 46, 100, 101, 118),
            m(99, 111, 100, 101, 112, 101, 110, 46, 97, 112, 112),
            m(112, 101, 110, 115, 46, 99, 108, 111, 117, 100),
            m(99, 115, 115, 45, 116, 114, 105, 99, 107, 115, 46, 99, 111, 109),
            m(99, 100, 112, 110, 46, 105, 111),
            m(112, 101, 110, 115, 46, 105, 111),
            m(103, 97, 110, 110, 111, 110, 46, 116, 118),
            m(99, 111, 100, 101, 99, 97, 110, 121, 111, 110, 46, 110, 101, 116),
            m(
              116,
              104,
              101,
              109,
              101,
              102,
              111,
              114,
              101,
              115,
              116,
              46,
              110,
              101,
              116,
            ),
            m(99, 101, 114, 101, 98, 114, 97, 120, 46, 99, 111, 46, 117, 107),
            m(116, 121, 109, 112, 97, 110, 117, 115, 46, 110, 101, 116),
            m(116, 119, 101, 101, 110, 109, 97, 120, 46, 99, 111, 109),
            m(116, 119, 101, 101, 110, 108, 105, 116, 101, 46, 99, 111, 109),
            m(112, 108, 110, 107, 114, 46, 99, 111),
            m(104, 111, 116, 106, 97, 114, 46, 99, 111, 109),
            m(119, 101, 98, 112, 97, 99, 107, 98, 105, 110, 46, 99, 111, 109),
            m(97, 114, 99, 104, 105, 118, 101, 46, 111, 114, 103),
            m(99, 111, 100, 101, 115, 97, 110, 100, 98, 111, 120, 46, 105, 111),
            m(99, 115, 98, 46, 97, 112, 112),
            m(115, 116, 97, 99, 107, 98, 108, 105, 116, 122, 46, 99, 111, 109),
            m(99, 111, 100, 105, 101, 114, 46, 105, 111),
            m(
              109,
              111,
              116,
              105,
              111,
              110,
              116,
              114,
              105,
              99,
              107,
              115,
              46,
              99,
              111,
              109,
            ),
            m(106, 115, 102, 105, 100, 100, 108, 101, 46, 110, 101, 116),
          ],
          t = e.length;
        -1 < --t;

      )
        if (-1 !== D.indexOf(e[t])) return !0;
      return (
        u &&
          window &&
          window.console &&
          console.log(
            m(
              87,
              65,
              82,
              78,
              73,
              78,
              71,
              58,
              32,
              97,
              32,
              115,
              112,
              101,
              99,
              105,
              97,
              108,
              32,
              118,
              101,
              114,
              115,
              105,
              111,
              110,
              32,
              111,
              102,
              32,
            ) +
              r +
              m(
                32,
                105,
                115,
                32,
                114,
                117,
                110,
                110,
                105,
                110,
                103,
                32,
                108,
                111,
                99,
                97,
                108,
                108,
                121,
                44,
                32,
                98,
                117,
                116,
                32,
                105,
                116,
                32,
                119,
                105,
                108,
                108,
                32,
                110,
                111,
                116,
                32,
                119,
                111,
                114,
                107,
                32,
                111,
                110,
                32,
                97,
                32,
                108,
                105,
                118,
                101,
                32,
                100,
                111,
                109,
                97,
                105,
                110,
                32,
                98,
                101,
                99,
                97,
                117,
                115,
                101,
                32,
                105,
                116,
                32,
                105,
                115,
                32,
                97,
                32,
                109,
                101,
                109,
                98,
                101,
                114,
                115,
                104,
                105,
                112,
                32,
                98,
                101,
                110,
                101,
                102,
                105,
                116,
                32,
                111,
                102,
                32,
                67,
                108,
                117,
                98,
                32,
                71,
                114,
                101,
                101,
                110,
                83,
                111,
                99,
                107,
                46,
                32,
                80,
                108,
                101,
                97,
                115,
                101,
                32,
                115,
                105,
                103,
                110,
                32,
                117,
                112,
                32,
                97,
                116,
                32,
                104,
                116,
                116,
                112,
                58,
                47,
                47,
                103,
                114,
                101,
                101,
                110,
                115,
                111,
                99,
                107,
                46,
                99,
                111,
                109,
                47,
                99,
                108,
                117,
                98,
                47,
                32,
                97,
                110,
                100,
                32,
                116,
                104,
                101,
                110,
                32,
                100,
                111,
                119,
                110,
                108,
                111,
                97,
                100,
                32,
                116,
                104,
                101,
                32,
                39,
                114,
                101,
                97,
                108,
                39,
                32,
                118,
                101,
                114,
                115,
                105,
                111,
                110,
                32,
                102,
                114,
                111,
                109,
                32,
                121,
                111,
                117,
                114,
                32,
                71,
                114,
                101,
                101,
                110,
                83,
                111,
                99,
                107,
                32,
                97,
                99,
                99,
                111,
                117,
                110,
                116,
                32,
                119,
                104,
                105,
                99,
                104,
                32,
                104,
                97,
                115,
                32,
                110,
                111,
                32,
                115,
                117,
                99,
                104,
                32,
                108,
                105,
                109,
                105,
                116,
                97,
                116,
                105,
                111,
                110,
                115,
                46,
                32,
                84,
                104,
                101,
                32,
                102,
                105,
                108,
                101,
                32,
                121,
                111,
                117,
                39,
                114,
                101,
                32,
                117,
                115,
                105,
                110,
                103,
                32,
                119,
                97,
                115,
                32,
                108,
                105,
                107,
                101,
                108,
                121,
                32,
                100,
                111,
                119,
                110,
                108,
                111,
                97,
                100,
                101,
                100,
                32,
                102,
                114,
                111,
                109,
                32,
                101,
                108,
                115,
                101,
                119,
                104,
                101,
                114,
                101,
                32,
                111,
                110,
                32,
                116,
                104,
                101,
                32,
                119,
                101,
                98,
                32,
                97,
                110,
                100,
                32,
                105,
                115,
                32,
                114,
                101,
                115,
                116,
                114,
                105,
                99,
                116,
                101,
                100,
                32,
                116,
                111,
                32,
                108,
                111,
                99,
                97,
                108,
                32,
                117,
                115,
                101,
                32,
                111,
                114,
                32,
                111,
                110,
                32,
                115,
                105,
                116,
                101,
                115,
                32,
                108,
                105,
                107,
                101,
                32,
                99,
                111,
                100,
                101,
                112,
                101,
                110,
                46,
                105,
                111,
                46,
              ),
          ),
        u || !console.log('object')
      );
    })(window ? window.location.host : ''),
    d = Array.isArray,
    a = [].slice,
    h =
      (((n = SplitText.prototype).split = function split(D) {
        this.isSplit && this.revert(),
          (this.vars = D = D || this.vars),
          (this._originals.length =
            this.chars.length =
            this.words.length =
            this.lines.length =
              0);
        for (
          var u,
            e,
            t,
            F = this.elements.length,
            i = D.tag ? D.tag : D.span ? 'span' : 'div',
            n = w(D.wordsClass, i),
            s = w(D.charsClass, i);
          -1 < --F;

        )
          (t = this.elements[F]),
            (this._originals[F] = t.innerHTML),
            (u = t.clientHeight),
            (e = t.clientWidth),
            E(t, D, n, s),
            C(t, D, this.chars, this.words, this.lines, e, u);
        return (
          this.chars.reverse(),
          this.words.reverse(),
          this.lines.reverse(),
          (this.isSplit = !0),
          this
        );
      }),
      (n.revert = function revert() {
        var e = this._originals;
        if (!e) throw "revert() call wasn't scoped properly.";
        return (
          this.elements.forEach(function (D, u) {
            return (D.innerHTML = e[u]);
          }),
          (this.chars = []),
          (this.words = []),
          (this.lines = []),
          (this.isSplit = !1),
          this
        );
      }),
      (SplitText.create = function create(D, u) {
        return new SplitText(D, u);
      }),
      SplitText);
  function SplitText(D, u) {
    i ||
      (function _initCore() {
        (Q = document), (F = window), (i = 1);
      })(),
      (this.elements = s(D)),
      (this.chars = []),
      (this.words = []),
      (this.lines = []),
      (this._originals = []),
      (this.vars = u || {}),
      l && this.split(u);
  }
  (h.version = '3.5.1'), (e.SplitText = h), (e.default = h);
  if (typeof window === 'undefined' || window !== e) {
    Object.defineProperty(e, '__esModule', { value: !0 });
  } else {
    delete e.default;
  }
});
